module Meevo.Plugins.Register {
    "use strict";

    import AccruedServiceSharingEnum = Meevo.Model.AccruedServiceSharingEnum;
    import FreezeSettingEnum = Meevo.Model.FreezeSettingEnum;

    export class MembershipsSection extends Meevo.Plugins.Register.RegisterSectionBase {
        memberships: any;
        membershipBenefit: any;
        membershipType: any;
        primaryClient: Meevo.Model.Client;
        autoGenerateMemberNumber: boolean;
        showMembershipTypeSelector: boolean = true;
        refundMembershipLines: any[];
        refundClient: Model.ClientListItem;
        refundMembershipNumber: string;
        needToSave: any;
        previewing: boolean;
        emailRequired: boolean = false;
        emailInput: boolean;

        isBenefitsSectionOpen:boolean = false;
        viewMembershipModel: any = {};
        benefitsType: any = 0;

        membershipNumberRegEx = new RegExp("^[0-9A-Za-z]+$");

        upgradeInfo: any = null;
        cancellationReasons: Model.MembershipCancellation[];
        hasHsaFsaMerchantAccount: boolean;
        isHostedPageAutomaticallySwitch: boolean;

        private _freezeSettingList = {
            [FreezeSettingEnum.AccruedServiceOnly]: 'LABEL_ACCRUED_SERVICES_ONLY',
            [FreezeSettingEnum.FullAccess]: 'LABEL_FULL_ACCESS?',
            [FreezeSettingEnum.MemberBenefitsOnly]: 'LABEL_MEMBER_BENEFITS_ONLY',
            [FreezeSettingEnum.NoAccess]: 'LABEL_NO_ACCESS',
        };
        private _accruedServiceSharingList = {
            [AccruedServiceSharingEnum.NoSharing]: 'LABEL_ACCRUED_SERVICE_SHARING_ENUM_NOSHARING',
            [AccruedServiceSharingEnum.OnlyDefinedUsers]: 'LABEL_ACCRUED_SERVICE_SHARING_ENUM_ONLYDEFINEDUSERS',
            [AccruedServiceSharingEnum.FamilyOnly]: 'LABEL_ACCRUED_SERVICE_SHARING_ENUM_FAMILYONLY',
            [AccruedServiceSharingEnum.Anyone]: 'LABEL_ACCRUED_SERVICE_SHARING_ENUM_ANYONE'
        };

        get $rootScope() { return this.registerContext.$rootScope; }
        get $timeout() { return this.registerContext.$timeout; }
        get $translate() { return this.registerContext.$translate; }
        get $mdDialog() { return this.registerContext.$mdDialog; }
        get $q() { return this.registerContext.$q; }
        get $filter() { return this.registerContext.$filter; }

        get endPoints() { return this.registerContext.appSettings.API_ENDPOINTS; }
        get dataService() { return this.registerContext.clientMemberDataService; }
        get modalService() { return this.registerContext.modalService; }

        get showUpgradeMembershipTile() {
            return this.registerContext.selectedClient && this.registerContext.selectedClient.canOfferMembershipUpgrade &&
                !this.upgradeInfo && !this.registerContext.sale.saleLines.find(saleLine =>
                    saleLine.clientId === this.registerContext.selectedClient.id && this.registerContext.isMembershipUpgrade(saleLine));
        }
        get recurringMemberships() {
            return this.memberships.filter(membership => membership.billingTypeEnum === Model.BillingTypeEnum.RecurringPayments &&
                membership.id !== this.upgradeInfo.membershipId);
        }

        private get upgradeSaleLineItem() {
            return this.membershipSaleLineItem as MembershipUpgradeSaleLineItem;
        }

        constructor(
            registerContext: Meevo.Plugins.Register.RegisterContext,
            protected businessInfoSettings: any
        ) {
            super(RegisterSectionTypeEnum.Memberships, registerContext, "memberships", Register.RegisterSectionCatTypeEnum.Sale);
        }

        protected securityKeys = Meevo.Components.Common.SecurityKeys;

        getMemberships() {
            let request: any = {
                pageNumber: 0,
                itemsPerPage: 1000,
                sortBy: 'Shortcut',
                sortDirection: Model.SortDirection.Ascending
            }
            if (this.membershipType) {
                request.criteria = {
                    membershipTypeId: this.membershipType.id
                }
            }
            this.isBenefitsSectionOpen = false;

            return this.dataService.getListPaged("membership", request).then((response: any) => {
                this.memberships = response;
                this.autoGenerateMemberNumber = this.registerContext.autoGenerateMembershipNumber;
            });
        }

        membershipTypeChange() {
            this.getMemberships();
        }

        saleLine: Model.SaleLine;
        membershipSaleLineItem: Meevo.Plugins.Register.MembershipSaleLineItem;
        previousEnrollmentFee: number;
        previousRecurringFee: number;
        previousRenewalFee: number;
        minStartDate: Date;
        maxStartDate: Date;
        minFirstPaymentDate: Date;
        maxFirstPaymentDate: Date;
        membership: any;
        autoRenewBeginsOn: string;
        autoRenewType: Model.AutoRenewTypeEnum;
        originalAutoRenewType: Model.AutoRenewTypeEnum;
        originalIsAutoRenew: boolean;
        isRecurring: boolean;
        isRenewalFeeRequired: boolean;
        scannedTransactionId: string = "";
        minRecurringFee: number;
        maxRecurringFee: number;
        minRenewalFee: number;
        maxRenewalFee: number;
        autoRenewPaidInFull: number = Model.AutoRenewTypeEnum.PaidInFull;
        autoRenewMonthly: number = Model.AutoRenewTypeEnum.Monthly;
        pausePreview: boolean = false;
        minAccruedServiceExpirationDate: Date;

        protected upgradeInProgress: ng.IPromise<any> = null;
        private addPending: boolean = false;

        add(_membership) {
            // Enforce invocation order with the upgrade() method.
            if (this.addPending) {
                return;
            }
            if (this.upgradeInProgress !== null) {
                this.addPending = true;
                this.upgradeInProgress.then(() => {
                    this.addPending = false;
                    this.add(_membership);
                });
                return;
            }

            this.registerContext.hideCheckoutButtons = true;
            this.showMembershipTypeSelector = false;
            this.minStartDate = moment().toDate();
            this.maxStartDate = moment().add(1, "years").toDate();

            this.pausePreview = true;

            try {
                this.membershipSaleLineItem = this.membershipSaleLineItem || new Meevo.Plugins.Register.MembershipSaleLineItem({});
                this.membershipSaleLineItem.displayName = _membership.displayName;
                this.membershipSaleLineItem.shortcut = _membership.shortcut;
                this.membershipSaleLineItem.membershipId = _membership.id;
                if (!this.membershipSaleLineItem.id) {
                    this.createDefaultPaymentAccountIfNecessary();
                    this.membershipSaleLineItem.client = this.upgradeInfo ? this.upgradeInfo : this.registerContext.selectedClient;
                    this.saleLine = {
                        quantity: 1,
                        client: this.upgradeInfo ? this.upgradeInfo : this.registerContext.selectedClient,
                        clientId: this.upgradeInfo ? this.upgradeInfo.id :
                            (this.registerContext.selectedClient ? this.registerContext.selectedClient.id : undefined),
                        clientType: this.upgradeInfo ? this.upgradeInfo.clientType : this.registerContext.selectedClientType,
                        saleType: Model.SalesTypeEnum.Membership,
                        showPoleMessage: Model.SaleLineStatusEnum.Added
                    };
                }
                this.showMembershipTypeSelector = false;
                this.getMembership(true);
            }
            catch(e) {
                this.pausePreview = false;
            }
        }

        populateUpgradeInfo(saleLine: Model.SaleLine = null) {
            this.minAccruedServiceExpirationDate = moment().toDate();
            this.upgradeInfo = angular.copy(saleLine ? saleLine.client : this.registerContext.selectedClient);
            this.upgradeInfo.clientType = saleLine ? saleLine.clientType : this.registerContext.selectedClientType;
        }

        // The membership meets every upgrade criterion except the freeze, so the freeze is what is blocking it.
        // Derived from the two server flags rather than membershipIndicatorStatus: that badge is
        // precedence-ordered and reports CCDueToExpire/InCancellation/Error/Suspended ahead of Frozen, and never
        // reports Frozen for a freeze that has not started, either of which would skip this message.
        get isUpgradeBlockedByFreeze() {
            const client = this.registerContext.selectedClient;
            return !!client && client.canOfferMembershipUpgrade === true && client.isEligibleForMembershipUpgrade === false;
        }

        upgrade() {
            // DISALLOW upgrade/downgrade while a freeze is in effect or scheduled.
            if (this.isUpgradeBlockedByFreeze) {
                this.modalService.alert('MESSAGE_UNABLE_UPGRADE_FROZEN_MEMBERSHIP', Meevo.Components.Modal.ModalTranslationModes.Translate);
                return;
            }

            const deferred = this.$q.defer();
            this.upgradeInProgress = deferred.promise;

            this.populateUpgradeInfo();

            var membershipUpgradeSaleLineItem = new Meevo.Plugins.Register.MembershipUpgradeSaleLineItem({});
            membershipUpgradeSaleLineItem.originalMembershipId = this.registerContext.selectedClient.clientMembershipId;
            membershipUpgradeSaleLineItem.originalMembershipNumber = membershipUpgradeSaleLineItem.membershipNumber = this.registerContext.selectedClient.membershipNumber;
            membershipUpgradeSaleLineItem.originalMembershipDisplayName = this.registerContext.selectedClient.membershipDisplayName;
            membershipUpgradeSaleLineItem.originalMembershipCancellationDate = moment().toDate();

            var promises = [
                this.registerContext.dataService.customMethodData(
                    `api/${this.registerContext.appSettings.API_ENDPOINTS.membershipManager}/${this.upgradeInfo.clientMembershipId}/Cancellation/Preview`,
                    'POST',
                    {}),
                this.registerContext.dataService.getItem('api/Membership/Client', this.upgradeInfo.clientMembershipId),
                this.getCancellationReasons()
            ];

            this.pausePreview = true;

            this.$q.all(promises)
                .then((responses: any[]) => {
                    const preview: Components.Common.ICancellationDates = responses[0].data;
                    const clientMembership: any = responses[1];

                    this.upgradeInfo.originalAccruedServiceExpireDate = preview.accruedServiceExpireDate;
                    membershipUpgradeSaleLineItem.paymentAccounts = clientMembership.paymentAccounts;
                    membershipUpgradeSaleLineItem.accruedServiceExpirationDate = preview.accruedServiceExpireDate;

                    const firstPaymentThisMonth = moment().date(clientMembership.paymentDayOfMonth).startOf('day');
                    membershipUpgradeSaleLineItem.firstPaymentDate = firstPaymentThisMonth.isBefore(moment().startOf('day')) ||
                        firstPaymentThisMonth.isSame(moment().startOf('day')) ?
                            firstPaymentThisMonth.add('month', 1).toDate() :
                            firstPaymentThisMonth.toDate();

                    membershipUpgradeSaleLineItem.originalMembershipEntityVersion = clientMembership.entityVersion;
                    this.membershipSaleLineItem = membershipUpgradeSaleLineItem;
                })
                .finally(() => {
                    this.pausePreview = false;
                    this.upgradeInProgress = null;
                    deferred.resolve(null);
                });
        }

        getCancellationReasons(): ng.IPromise<any> {
            if (this.cancellationReasons) {
                return this.$q.resolve(null);
            }

            return this.dataService.getListPaged(this.registerContext.appSettings.API_ENDPOINTS.membershipCancellation, {
                criteria: {
                    objectState: Meevo.Model.ObjectStateEnum.Active
                }
            }).then(response => this.cancellationReasons = response);
        }

        createDefaultPaymentAccountIfNecessary() {
            if (!this.membershipSaleLineItem.paymentAccounts) {
                this.membershipSaleLineItem.paymentAccounts = [];
            }

            if (this.membershipSaleLineItem.paymentAccounts.length == 0 && this.registerContext.getMerchantAccountCanCreateTokens()) {
                this.membershipSaleLineItem.paymentAccounts.push({
                    paymentAccountType: Model.PaymentAccountTypeEnum.Card,
                    merchantAccountId: this.registerContext.selectedDrawer.merchantAccountId,
                    directManualEntry: this.registerContext.getMerchantAccountDirectManualEntry()
                })
            }
        }
        getMembership(reset: boolean) {
            if (this.membershipSaleLineItem.membershipId == undefined)
                return;

            this.dataService.getItem("membership", this.membershipSaleLineItem.membershipId).then((response: any) => {
                this.membership = response;
                if (reset) {
                    this.membershipSaleLineItem.startDate = moment().toDate();
                    this.membershipSaleLineItem.recurringFee = response.membershipMemberSettings[0].recurringFee;
                    this.membershipSaleLineItem.enrollmentFee = response.membershipMemberSettings[0].enrollmentFee;
                    this.membershipSaleLineItem.isAutoRenewed = response.autoRenewTypeEnum !== Model.AutoRenewTypeEnum.No;
                    //this.membershipSaleLineItem.renewalFee = response.membershipMemberSettings[0].renewalFee;
                    this.membershipSaleLineItem.autoRenewType = (response.autoRenewTypeEnum == Model.AutoRenewTypeEnum.Both) ? Model.AutoRenewTypeEnum.Monthly : null;
                        //(response.autoRenewTypeEnum == Model.AutoRenewTypeEnum.No || response.billingTypeEnum != Model.BillingTypeEnum.PaidInFull) ? null : response.autoRenewTypeEnum;
                }
                this.previousEnrollmentFee = this.membershipSaleLineItem.enrollmentFee;
                this.previousRecurringFee = this.membershipSaleLineItem.recurringFee;
                //this.previousRenewalFee = this.membershipSaleLineItem.renewalFee;
                this.autoRenewType = this.membershipSaleLineItem.autoRenewType;
                this.originalAutoRenewType = response.autoRenewTypeEnum;
                this.originalIsAutoRenew = response.autoRenewTypeEnum !== Model.AutoRenewTypeEnum.No;
                this.isRecurring = response.billingTypeEnum === Model.BillingTypeEnum.RecurringPayments;
                this.isRenewalFeeRequired = response.autoRenewTypeEnum !== Model.AutoRenewTypeEnum.No;
                this.minRecurringFee = response.membershipMemberSettings[0].minRecurringFee;
                this.maxRecurringFee = response.membershipMemberSettings[0].recurringFee;
                //this.minRenewalFee = response.membershipMemberSettings[0].minRenewalFee;
                //this.maxRenewalFee = response.membershipMemberSettings[0].renewalFee;
                this.membershipSaleLineItem.isTaxExempt = !response.isTaxable;
                this.membershipSaleLineItem.minEnrollmentFee = response.membershipMemberSettings[0].minEnrollmentFee;
                this.membershipSaleLineItem.maxEnrollmentFee = response.membershipMemberSettings[0].enrollmentFee;
            }).finally(() => {
                this.pausePreview = false;
                this.preview(reset && !this.upgradeInfo, null, !this.upgradeInfo);
            });
        }

        validateMemberNumber(): ng.IPromise<boolean> {
            let deferred = this.$q.defer();

            if (this.autoGenerateMemberNumber) {
                this.membershipSaleLineItem.membershipNumber = '';
                deferred.resolve(true);
            } else {
                if (this.membershipSaleLineItem.membershipNumber == undefined || this.membershipSaleLineItem.membershipNumber.trim().length === 0) {
                    this.modalService.okCancelHandler("MESSAGE_MEMBERSHIP_NUMBER_GENERATE")
                        .then((response) => {
                            deferred.resolve(response);
                        });
                } else {
                    deferred.resolve(true);
                }
            }
            return deferred.promise;
        }

        membershipNumberBlur() {
            this.preview(false, true, false);
        }

        membershipNumberChange() {
            this.previewing = true;
        }

        edit(saleLine: Model.SaleLine) {
            var upgradeSaleLineItem = <MembershipUpgradeSaleLineItem>saleLine.item;
            if (moment(upgradeSaleLineItem.originalMembershipCancellationDate).isBefore(moment().startOf('day'))) {
                upgradeSaleLineItem.originalMembershipCancellationDate = moment().toDate();
            }
            this.registerContext.hideCheckoutButtons = true;

            this.showMembershipTypeSelector = false;
            this.saleLine = saleLine;
            this.membershipSaleLineItem = jQuery.extend(true, {}, saleLine.item);
            this.createDefaultPaymentAccountIfNecessary();

            if (upgradeSaleLineItem.originalMembershipId) {
                this.populateUpgradeInfo(saleLine);
                this.getCancellationReasons().then(() => this.upgradeSaleLineItem.originalMembershipCancellationReason = this.cancellationReasons
                    .find(reason => reason.id === upgradeSaleLineItem.originalMembershipCancellationReason.id));
            }

            this.getMembership(false);
        }

        preview(clientChanged: boolean = false, membershipNumberChanged: boolean = false, changeFirstPaymentDate: boolean = true) {
            if (this.pausePreview) {
                return;
            }

            if (this.membershipSaleLineItem.startDate) {
                this.minFirstPaymentDate = moment(this.membershipSaleLineItem.startDate).add(1, "days").toDate();
                // Need to clear out so that if increase date, validation error doesn't appear
                this.maxFirstPaymentDate = undefined;
                let clientId: string = null;
                let clientMembershipId: string = this.membershipSaleLineItem.id;
                // Only care about checking client id for existing membership if its a new
                // membership or its an existing where the client is changed
                if (this.membershipSaleLineItem.client && (!this.membershipSaleLineItem.id ||
                    (<Register.MembershipSaleLineItem>this.saleLine.item).clientId !== this.membershipSaleLineItem.client.id)) {
                    clientId = this.membershipSaleLineItem.client.id;
                    clientMembershipId = null;
                }

                let firstPaymentDate = null;
                if (!changeFirstPaymentDate) {
                    firstPaymentDate = this.membershipSaleLineItem.firstPaymentDate;
                }

                this.dataService.getDateDependencies(this.membership.id,
                    this.membershipSaleLineItem.startDate,
                    false,
                    firstPaymentDate,
                    null,
                    clientId,
                    this.membershipSaleLineItem.isAutoRenewed,
                    this.membershipSaleLineItem.membershipNumber,
                    clientMembershipId,
                    _.where(this.registerContext.sale.saleLines, { saleType: Model.SalesTypeEnum.Membership })
                        .map((membershipSaleLine) => {
                            return membershipSaleLine.item.id;
                        }),
                    this.membershipSaleLineItem.isAutoRenewed ? this.membershipSaleLineItem.autoRenewType : null,
                    !!this.upgradeInfo
                )
                    .then((response: any) => {
                        this.previewing = false;
                        if (response.responseStatus) {
                            this.needToSave = null;
                            // This workflow where you change existing membership saleline to an invalid client generates two alerts so just swallow the first one.
                            if (this.membershipSaleLineItem.id && this.membershipSaleLineItem.client && clientChanged) {
                            }
                            else {
                                this.modalService.alert(response.responseStatus.message);
                            }
                            if (clientChanged) {
                                this.membershipSaleLineItem.client = null;
                                this.$timeout(() => {
                                    // get preview without client chosen
                                    this.preview();
                                });
                            }
                            else if (membershipNumberChanged) {
                                this.membershipSaleLineItem.membershipNumber = this.upgradeInfo ?
                                    this.upgradeSaleLineItem.originalMembershipNumber :
                                    '';
                            }
                        } else {
                            this.membershipSaleLineItem.expiresOnDate = response.expiresOnDate;
                            this.autoRenewBeginsOn = response.renewalBeginsOn;
                            this.$timeout(() => {
                                this.maxFirstPaymentDate = response.firstPaymentDateTill;
                                if (changeFirstPaymentDate) {
                                    this.membershipSaleLineItem.firstPaymentDate = response.firstPaymentDateTill;
                                }
                            });
                            this.membershipSaleLineItem.isBillable = response.isBillable;
                            this.minRenewalFee = response.minimumRenewalFee;
                            this.maxRenewalFee = response.defaultRenewalFee;
                            this.membershipSaleLineItem.renewalFee = this.maxRenewalFee;
                            this.previousRenewalFee = this.membershipSaleLineItem.renewalFee;

                            if (this.needToSave) {
                                this.needToSave();
                            }
                        }
                    });
            } else {
                this.membershipSaleLineItem.expiresOnDate = undefined;
                this.autoRenewBeginsOn = "";
            }
        }

        toggleAutoRenewal() {
            if (!this.membershipSaleLineItem.isAutoRenewed) {
                this.membershipSaleLineItem.renewalFee = this.maxRenewalFee;
            }
            this.preview(false, false, false);
        }

        autoRenewalChanged() {
            this.membershipSaleLineItem.autoRenewType = this.autoRenewType;
            this.isRenewalFeeRequired = this.membershipSaleLineItem.isAutoRenewed = (this.autoRenewType != Model.AutoRenewTypeEnum.No);
            this.preview(false, false, false);
        }

        clientChanged() {
            if (this.membershipSaleLineItem.client) {
                this.preview(true, false, false);
            }
        }

        clearClient() {
            this.membershipSaleLineItem.client = undefined;
            this.minStartDate = moment().toDate();
        }

        checkForEmail() {
            this.emailRequired = false;
            if (this.membershipSaleLineItem.client && this.businessInfoSettings.membershipSettings.requireEmailForMembershipSale) {
                this.emailRequired = true;
                return this.dataService
                    .customMethodData(`api/Client/${this.membershipSaleLineItem.client.id}/NotificationClient`, "GET", null)
                    .then((clientData) => {
                        this.primaryClient = clientData.data;
                        if (!clientData.data.emailAddress || clientData.data.emailAddress.trim() === "") {
                            let options: Meevo.Components.Modal.IModalOptions = {
                                templateUrl: "app/plugins/register/memberships/EmailModal.html",
                                controller: "meevo.plugins.register.EmailModalController",
                                controllerAs: "vm",
                                bindToController: true,
                                locals: {
                                    registerContext: this.registerContext,
                                    clientData: this.primaryClient
                                }
                            }
                            return this.modalService.showCustom(options);
                        } else {
                            this.emailInput = true;
                        }
                    });
            }

            var deferred = this.$q.defer();
            deferred.resolve();
            return deferred.promise;
        }

        emailInputSave(isValid: boolean) {
            if (!isValid) {
                return;
            }
            if (this.primaryClient.emailAddress !== "" && this.primaryClient.emailAddress != undefined) {
                this.dataService.customMethodData("api/Client/", "PUT", this.primaryClient)
                //proper way, but can't do it due to ClientObjectStatePatch route
                //this.dataService.customMethodData(`api/Client/${this.primaryClient.id}`, "PATCH", { emailAddress: this.primaryClient.emailAddress })
                    .then(() => {
                        this.emailInput = true;
                        this.$mdDialog.hide();
                    });
            }
        }

        emailInputCancel() {
            this.emailInput = false;
            this.$mdDialog.hide();
        }

        enrollmentFeeBlur() {
            if (this.membershipSaleLineItem.enrollmentFee > this.membershipSaleLineItem.maxEnrollmentFee) {
                this.$timeout(() => this.membershipSaleLineItem.enrollmentFee = this.membershipSaleLineItem.maxEnrollmentFee);
            }
            else if (this.membershipSaleLineItem.enrollmentFee < this.membershipSaleLineItem.minEnrollmentFee) {
                let meevoCurrency = this.$filter("meevoCurrency") as any;
                let message = this.$translate.instant("MESSAGE_MIN_MEMBERSHIP_FEE", {
                    feeDisplayName: "enrollment",
                    minFeeValue: meevoCurrency(this.membershipSaleLineItem.minEnrollmentFee)
                });
                this.modalService.alert(message, Components.Modal.ModalTranslationModes.DoNotTranslate)
                    .then(() =>
                        this.$timeout(() => this.membershipSaleLineItem.enrollmentFee = this.previousEnrollmentFee));
            }
            else {
                this.previousEnrollmentFee = this.membershipSaleLineItem.enrollmentFee;
            }
        }

        recurringFeeBlur() {
            if (this.membershipSaleLineItem.recurringFee > this.maxRecurringFee) {
                this.$timeout(() => this.membershipSaleLineItem.recurringFee = this.maxRecurringFee);
            }
            else if (this.membershipSaleLineItem.recurringFee < this.minRecurringFee) {
                let meevoCurrency = this.$filter("meevoCurrency") as any;
                let message = this.$translate.instant("MESSAGE_MIN_MEMBERSHIP_FEE", {
                    feeDisplayName: "recurring",
                    minFeeValue: meevoCurrency(this.minRecurringFee)
                });
                this.modalService.alert(message, Components.Modal.ModalTranslationModes.DoNotTranslate)
                    .then(() =>
                        this.$timeout(() => this.membershipSaleLineItem.recurringFee = this.previousRecurringFee));
            }
            else {
                this.previousRecurringFee = this.membershipSaleLineItem.recurringFee;
            }
        }

        renewalFeeBlur() {
            if (this.membershipSaleLineItem.renewalFee > this.maxRenewalFee) {
                this.$timeout(() => this.membershipSaleLineItem.renewalFee = this.maxRenewalFee);
            }
            else if (this.membershipSaleLineItem.renewalFee < this.minRenewalFee) {
                let meevoCurrency = this.$filter("meevoCurrency") as any;
                let message = this.$translate.instant("MESSAGE_MIN_MEMBERSHIP_FEE", {
                    feeDisplayName: "renewal",
                    minFeeValue: meevoCurrency(this.minRenewalFee)
                });
                this.modalService.alert(message, Components.Modal.ModalTranslationModes.DoNotTranslate)
                    .then(() =>
                        this.$timeout(() => this.membershipSaleLineItem.renewalFee = this.previousRenewalFee));
            }
            else {
                this.previousRenewalFee = this.membershipSaleLineItem.renewalFee;
            }
        }

        paymentAccountRequired() {
            return this.membership && this.membershipSaleLineItem.isBillable &&
                ((this.membership.billingTypeEnum === Model.BillingTypeEnum.PaidInFull &&
                    this.membershipSaleLineItem.isAutoRenewed && this.membershipSaleLineItem.renewalFee > 0 && this.maxRenewalFee > 0) ||
                    (this.membership.billingTypeEnum === Model.BillingTypeEnum.RecurringPayments &&
                        ((this.membershipSaleLineItem.recurringFee > 0 && this.maxRecurringFee > 0) ||
                        (this.membershipSaleLineItem.isAutoRenewed && this.membershipSaleLineItem.renewalFee > 0 && this.maxRenewalFee > 0))));
        }

        save(isValid) {
            this.needToSave = null;
            if (!isValid) {
                return;
            }

            // If clicking save from membership textbox, need to wait for preview call made onblur to return before actually saving
            if (this.previewing) {
                this.needToSave = () => { this.save(isValid) };
                return;
            }

            this.validateMemberNumber()
                .then((response) => {
                    if (!response) {
                        return;
                    }

                    this.checkForEmail()
                        .then(() => {
                            if (this.emailRequired && !this.emailInput) {
                                return;
                            }

                            this.membershipSaleLineItem.clientId = this.membershipSaleLineItem.client.id;
                            this.saleLine.baseItemPrice = this.membershipSaleLineItem.enrollmentFee;
                            this.saleLine.finalItemPrice = this.membershipSaleLineItem.enrollmentFee;
                            this.saleLine.isDirty = true;

                            let clone = jQuery.extend(true, {}, this.membershipSaleLineItem);
                            if (!this.paymentAccountRequired()) {
                                clone.paymentAccounts = [];
                            }
                            this.saleLine.item = clone;

                            if (this.membershipSaleLineItem.id) {
                                this.registerContext.recalculateSale()
                                    .then(() => {
                                        this.reset();
                                    });
                            } else {
                                this.registerContext.tempSaleLines = [ this.saleLine ];
                                this.registerContext.selectSection(RegisterSectionTypeEnum.Employee);
                            }
                        });
                });
        }

        isDirty() {
            return !this.registerContext.isRefundMode && !angular.isUndefined(this.membershipSaleLineItem) && angular.isUndefined(this.membershipSaleLineItem.id);
        }

        refundClientChanged() {
            this.refundMembershipNumber = '';
            this.loadHistory();
        }

        loadHistory() {
            this.refundSubTotal = 0;
            let request: any = {
                pageNumber: 0,
                itemsPerPage: 1000,
                sortDirection: Model.SortDirection.Descending,
                criteria: {
                    saleType: Model.SalesTypeEnum.Membership,
                    clientId: !!this.refundClient ? this.refundClient.id : null,
                    membershipNumber: this.refundMembershipNumber,
                    includeAuthorizationPaymentRequest: true
                }
            }

            this.dataService.getListPaged("saleLine", request)
                .then(saleLines => {
                    saleLines.forEach((saleLine: any) => {
                        if (_(this.registerContext.sale.saleLines)
                            .find(ticketSaleLine => {
                                return ticketSaleLine.saleType === Model.SalesTypeEnum.Membership && ticketSaleLine.item.id === saleLine.item.id;
                            })) {
                            saleLine.isRefund = true;
                            this.isRefundChanged(saleLine);
                        }
                    });
                    this.refundMembershipLines = saleLines;
                });
        }

        refundMembershipNumberChanged() {
            this.refundClient = null;
            if (this.refundMembershipNumber) {
                this.loadHistory();
            }
        }

        applyRefundItems() {
            for (var i = this.registerContext.sale.saleLines.length - 1; i >= 0; i--) {
                let saleLine = this.registerContext.sale.saleLines[i];

                if (saleLine.saleType === Model.SalesTypeEnum.Membership &&
                    saleLine.isRefund &&
                    !_(this.refundMembershipLines)
                        .find(refundSaleLine => {
                            return refundSaleLine.item.id === this.registerContext.sale.saleLines[i].item.id && refundSaleLine.isRefund;
                        })) {
                    this.registerContext.sale.saleLines.splice(i, 1);
                }
            }

            this.refundMembershipLines.forEach(saleLine => {
                if (saleLine.isRefund) {
                    saleLine.client = this.registerContext.selectedClient;
                    saleLine.itemDisplayName = "Membership Enrollment Fee";
                    this.registerContext.addRefundSaleLine(saleLine, Model.SalesTypeEnum.Membership);
                }
            });

            this.registerContext.recalculateSale();
        }

        reset() {
            if (this.registerContext.isRefundMode) {
                this.scannedTransactionId = "";
                this.refundClient = this.registerContext.selectedClient;
                this.loadHistory();
                this.showMembershipTypeSelector = true;
            } else {
                this.autoGenerateMemberNumber = false;
                this.saleLine = undefined;
                this.membershipSaleLineItem = undefined;
                this.autoRenewType = Model.AutoRenewTypeEnum.No;
                if (!this.registerContext.isRefundMode) {
                    this.registerContext.hideCheckoutButtons = false;
                }

                this.getMemberships();
                this.setHasHsaFsaMerchantAccounts();
                this.isBenefitsSectionOpen = false;
                this.showMembershipTypeSelector = true;
                this.upgradeInfo = null;
                this.isHostedPageAutomaticallySwitch = this.registerContext.getIsHostedPageAutomaticallySwitch();
            }
        }

        delete(saleLine) {
            if ((this.membershipSaleLineItem && this.membershipSaleLineItem.id === saleLine.item.id) || this.registerContext.isRefundMode) {
                this.reset();
            }
        }

        gotoMembershipTypeSelector() {
            this.showMembershipTypeSelector = true;
            this.registerContext.navigate(RegisterSectionTypeEnum.Memberships, this.membershipSaleLineItem, false, false, false);
        }

        isRefundChanged(saleLine) {
            if (saleLine.isRefund) {
                const refundSaleLines: Model.SaleLine[] = this.refundMembershipLines.filter(line => line.isRefund);

                if (this.registerContext.isMismatch(this.registerContext.getAuthorizationPaymentRequestId(this.registerContext.sale), saleLine.authorizationPaymentRequestId) ||
                    this.hasAuthorizationPaymentRequestIdMismatch(refundSaleLines)
                ) {
                    this.registerContext.displayRefundMismatchMessage(false, true);
                    saleLine.isRefund = false;
                    return;
                }

                this.refundSubTotal = this.registerContext.addNormalizedNumbers(this.refundSubTotal, saleLine.item.enrollmentFee);
            } else {
                this.refundSubTotal = this.registerContext.subtractNormalizedNumbers(this.refundSubTotal, saleLine.item.enrollmentFee);
            }
        }

        getClientDisplayName = (saleLine) => {
            return saleLine.clientType === Model.ClientTypeEnum.Client
                ? `${saleLine.clientLastName}, ${saleLine.clientFirstName}`
                : Model.ClientTypeEnum[saleLine.clientType].replace("Anonymous", "Anonymous ");
        }

        refundTransaction() {
            this.registerContext.getSaleLinesToRefundFromTransactionId(this.scannedTransactionId).then(() => { this.scannedTransactionId = ""; });
        }

        isAutoRenew() {
            return this.originalIsAutoRenew && this.membershipSaleLineItem && this.membershipSaleLineItem.isAutoRenewed;
        }

        viewBenefits() {
            this.isBenefitsSectionOpen = true;
            this.dataService.customMethodData("api/Membership/Client/Preview/Benefit", "POST", { 'MembershipId': this.membershipSaleLineItem.membershipId}).then((data: any) => {
                this.membershipBenefit = data.data;
                this.changeViewModel();
            });
        }
        closeBenefits() {
            this.isBenefitsSectionOpen = false;
        }
        changeViewModel(): void {
            if (this.benefitsType === 0) {
                this.viewMembershipModel = this.membershipBenefit['primaryMemberBenefit'];
            } else {
                this.viewMembershipModel = this.membershipBenefit['secondaryMemberBenefit'];
            }

            this.viewMembershipModel.generalInfo = this.viewMembershipModel.generalInfo ? this.viewMembershipModel.generalInfo : {};
            this.membershipBenefit['accruedServiceSharing'] = this._accruedServiceSharingList[this.membershipBenefit['accruedServiceSharingEnum']];

            _.each(this.membershipBenefit['membershipFreezeSettings'], (item: Model.IMembershipFreezeSetting) => {
                item.displayName = this._freezeSettingList[item.freezeSetting];
            });
        };

        normalizeDiscountAmount(amount, isPercent) {
            if (isPercent) {
                return amount ? Math.floor(amount * 100) : 0;
            }
            return amount;
        }

        isMembershipRenewalTypeBoth() {
            return this.originalAutoRenewType == Meevo.Model.AutoRenewTypeEnum.Both;
        }

        canApplyRefund(): boolean {
            return _(this.refundMembershipLines).any(saleLine => saleLine.isRefund);
        }

        private setHasHsaFsaMerchantAccounts() {
            this.registerContext.getHasHsaFsaMerchantAccounts().then((result) => {
                this.hasHsaFsaMerchantAccount = result;
            });
        }
    }
}